import axios from "axios";
import React, { useState, useReducer } from "react";
import Spinner from "react-bootstrap/Spinner";
import { API_CONSTANTS } from "../../../../../../API_CONSTANTS";
import { useParams } from "react-router";
import moment from "moment";
import Edit from "./Edit";
import LockDay from "./LockDay";
import Toast from "../../../../../../Components/Toast/Toast";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import calendarReloadIcon from "../../../../../../assets/icons/calendar-reload-icon.png";
import { useSelector } from "react-redux";
// slotsReducer
const slotsReducer = (state, action) => {
  switch (action.type) {
    case "ROTATING_TRUE": {
      return {
        ...state,
        rotating: true,
      };
    }
    case "ROTATING_FALSE": {
      return {
        ...state,
        rotating: false,
      };
    }
    case "PENDING": {
      return {
        ...state,
        loading: true,
      };
    }
    case "FULFILLED": {
      return {
        ...state,
        loading: false,
        value: action.payload,
      };
    }
    default:
      return {
        ...state,
        [action.target.name]: action.target.value,
      };
  }
};

// SlotsCalender
export default function AvailabilityCalender() {
  const { duration } = useSelector((state) => state.getSessionReducer.value);
  const [open, setOpen] = useState(false);
  const [slots, setSlots] = useReducer(slotsReducer, {
    loading: false,
    rotating: false,
    value: null,
  });
  const [toast, setToast] = useState({
    icon: "",
    message: "",
    iconColor: "",
    cName: "",
  });
  const { loading, value, rotating } = slots;
  const params = useParams();

  // Normalize response: handle new { video: [...], onsite: [...] } or old flat array format
  const normalizeSlottingResponse = (response) => {
    const tagSlotAndSessions = (slot, appointmentType) => {
      const normalizedSlotDate =
        slot?.slot_date ?? slot?.slotDate ?? slot?.date ?? "";

      const sessions = Array.isArray(slot?.day_sessions) ? slot.day_sessions : [];
      const taggedSessions = sessions.map((session) => {
        if (!session || typeof session !== "object") return session;

        const normalizedStartTime =
          session.startTime ?? session.start_time ?? session.start ?? "";
        const normalizedEndTime =
          session.endTime ?? session.end_time ?? session.end ?? "";

        const next = {
          ...session,
          startTime: normalizedStartTime,
          endTime: normalizedEndTime,
          appointment_type: appointmentType,
        };

        if (appointmentType === "onsite") {
          next.onsite = session.onsite ?? true;
          next.is_onsite = session.is_onsite ?? true;
        }

        return next;
      });

      return {
        ...slot,
        // force a consistent date field for merging/rendering
        slot_date: normalizedSlotDate,
        appointment_type: appointmentType,
        day_sessions: taggedSessions,
      };
    };

    const mergeBySlotDate = (slots = []) => {
      const merged = slots.reduce((acc, slot) => {
        const slotDate = slot?.slot_date ?? slot?.slotDate;
        if (!slotDate) return acc;

        const existing = acc.get(slotDate);
        if (!existing) {
          acc.set(slotDate, {
            ...slot,
            day_sessions: Array.isArray(slot?.day_sessions) ? slot.day_sessions : [],
          });
          return acc;
        }

        const nextSessions = [
          ...(Array.isArray(existing.day_sessions) ? existing.day_sessions : []),
          ...(Array.isArray(slot?.day_sessions) ? slot.day_sessions : []),
        ];

        acc.set(slotDate, {
          ...existing,
          booking: existing.booking || slot.booking,
          lock_day: existing.lock_day || slot.lock_day,
          day_sessions: nextSessions,
        });

        return acc;
      }, new Map());

      const mergedDays = Array.from(merged.values());
      return mergedDays.sort((a, b) => new Date(a.slot_date) - new Date(b.slot_date));
    };

    if (Array.isArray(response)) {
      const tagged = response.map((slot) => {
        const rawType = String(
          slot?.appointment_type || slot?.type || slot?.mode || ""
        ).toLowerCase();

        const appointmentType =
          rawType.includes("onsite") || rawType.includes("in_person")
            ? "onsite"
            : "video";

        return tagSlotAndSessions(slot, appointmentType);
      });

      return mergeBySlotDate(tagged);
    }
    if (response && typeof response === 'object') {
      const video = Array.isArray(response.video) ? response.video : [];
      const onsite = Array.isArray(response.onsite) ? response.onsite : [];

      // Merge and FORCE appointment_type to match the section it came from
      const mergedByType = [
        ...video.map((slot) => tagSlotAndSessions(slot, "video")),
        ...onsite.map((slot) => tagSlotAndSessions(slot, "onsite")),
      ];

      return mergeBySlotDate(mergedByType);
    }
    return [];
  };

  // handling collapse button function
  const handleClick = () => {
    // Always refresh when opening the dropdown so newly-saved slots appear
    if (!open) {
      setSlots({ type: "PENDING" });
      axios
        .get(
          `${API_CONSTANTS.BASEURL}admin/doctors/${params.id}/slotting_calendar`,
          {
            headers: API_CONSTANTS.headers(),
          }
        )
        .then((res) => {
          const raw = res?.data?.response;
          const normalized = normalizeSlottingResponse(raw);

          setSlots({ type: "FULFILLED", payload: normalized });
        })
        .catch((err) => {
          setSlots({ type: "REJECTED", payload: err });
        });
    }
  };
  // day on off fucntion
  const handleDayOnOff = (date) => {
    axios
      .patch(
        `${API_CONSTANTS.BASEURL}admin/doctors/${params.id}/appointment/lockDay`,
        {
          slot_date: date,
        },
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((res) => {
        setToast({
          icon: faCheckCircle,
          message: res.data.response.message,
          iconColor: "",
          cName: "show show-success",
        });
        setTimeout(() => {
          setToast({
            icon: "",
            message: "",
            iconColor: "",
            cName: "",
          });
        }, 1500);
      })
      .then(() =>
        axios
          .get(
            `${API_CONSTANTS.BASEURL}admin/doctors/${params.id}/slotting_calendar`,
            {
              headers: API_CONSTANTS.headers(),
            }
          )
          .then((res) => {
            const raw = res?.data?.response;
            const normalized = normalizeSlottingResponse(raw);

            setSlots({ type: "FULFILLED", payload: normalized });
          })
          .catch((err) => {
            setSlots({ type: "REJECTED", payload: err });
          })
      )
      .catch((err) => {
        setToast({
          icon: faTimesCircle,
          message: err.data.response.message,
          iconColor: "",
          cName: "show show-danger",
        });
        setTimeout(() => {
          setToast({
            icon: "",
            message: "",
            iconColor: "",
            cName: "",
          });
        }, 1500);
      });
  };
  // handling updated time slot function
  const handleUpdatedTimeSlot = () => {
    setSlots({ type: "ROTATING_TRUE" });
    axios
      .get(
        `${API_CONSTANTS.BASEURL}admin/doctors/${params.id}/slotting_calendar`,
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((res) => {
        const raw = res?.data?.response;
        const normalized = normalizeSlottingResponse(raw);

        setSlots({ type: "FULFILLED", payload: normalized });
      })
      .then(() => setSlots({ type: "ROTATING_FALSE" }))
      .catch((err) => {
        setSlots({ type: "REJECTED", payload: err });
      });
  };

  const formatSlotTime = (time = "") => {
    if (!time) return "";
    return moment({
      year: 2010,
      month: 3,
      day: 5,
      hour: parseInt(time.slice(0, 2), 10),
      minute: parseInt(time.slice(-2), 10),
      second: 3,
      millisecond: 123,
    }).format("LT");
  };

  const getSessionType = (session = {}) => {
    const rawType = String(
      session.appointment_type || session.type || session.mode || ""
    ).toLowerCase();

    if (rawType.includes("onsite") || rawType.includes("in_person")) {
      return "onsite";
    }

    if (
      rawType.includes("online") ||
      rawType.includes("video") ||
      rawType.includes("chat")
    ) {
      return "online";
    }

    if (session.onsite === true || session.is_onsite === true) {
      return "onsite";
    }

    return "online";
  };

  const renderSessionRow = (session, index, item, type) => (
    <span
      className="w-100 d-flex justify-content-between align-items-center px-1"
      key={`${type}-${index}-${session.startTime}-${session.endTime}`}
      style={{
        color: item.lock_day ? "#CCCCCC" : "#000",
      }}
    >
      <p className="m-0">{formatSlotTime(session.startTime)}</p>
      <p className="m-0">{formatSlotTime(session.endTime)}</p>
      {type === "online" ? (
        <span>
          <label
            htmlFor="video-chat"
            className="form-check-label video-chat"
            style={{
              cursor: "pointer",
              color: session.video === true ? "#009B94" : "#777",
            }}
          >
            <i
              className="fas fa-video"
              style={{
                color: item.lock_day ? "#CCCCCC" : "#009B94",
              }}
            ></i>
            <input
              type="checkbox"
              id="video-chat"
              style={{ display: "none" }}
            />
          </label>
        </span>
      ) : (
        <span
          style={{
            color: item.lock_day ? "#CCCCCC" : "#FF6760",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          Onsite
        </span>
      )}
    </span>
  );

  return (
    <div className="row m-4 rounded p-2 bg-light">
      <div className="col-12">
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-end" style={{ columnGap: 20 }}>
            <button
              className="d-flex justify-content-end  text-1"
              style={{
                outline: "none",
                borderRadius: "5px",
                background: "none",
                border: "none",
                color: "#009B94",
                fontSize: "25px",
                transition: "all ease-in 0.5",
              }}
              onClick={handleUpdatedTimeSlot}
            >
              <img
                src={calendarReloadIcon}
                alt=""
                className={rotating ? "rotating" : ""}
              />
            </button>
            <button
              className="d-flex justify-content-end  text-1"
              onClick={() => {
                setOpen(!open);
                handleClick();
              }}
              aria-controls="example-collapse-text"
              aria-expanded={open}
              style={{
                outline: "none",
                borderRadius: "5px",
                background: "none",
                border: "none",
                color: "#009B94",
                fontSize: "25px",
                transition: "all ease-in 0.5",
              }}
            >
              {open || <i className="fas fa-sort-down"></i>}
              {open && <i className="fas fa-caret-up"></i>}
            </button>
          </div>

          {open && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ transition: "all ease-in 0.5" }}
            >
              {
                <div className="d-flex justify-content-center mt-4 flex-column w-100">
                  {loading && (
                    <div className="d-flex justify-content-center align-items-center">
                      <Spinner
                        animation="border text-center"
                        style={{ color: "#24AAA4" }}
                      />
                    </div>
                  )}

                  <div className="d-flex justify-content-start align-items-center w-100 flex-wrap">
                    {value === null
                      ? []
                      : value.map((item, index) => (
                          <div
                            key={item?.slot_date || index}
                            className={
                              " d-flex flex-column justify-content-center align-items-center border m-2 rounded p-1 m-1 " +
                              (item.booking ? "booked" : "") +
                              (item.lock_day ? " disabled" : "")
                            }
                            style={{ width: 222, position: "relative" }}
                          >
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <span
                                style={{
                                  color: item.lock_day ? "#CCCCCC" : "#000",
                                }}
                              >
                                {item.slot_day.slice(0, 1).toUpperCase() +
                                  item.slot_day.slice(1, 3) +
                                  "," +
                                  " " +
                                  moment(item.slot_date)
                                    .format("LL")
                                    .slice(0, 3)}
                              </span>
                              <span className="d-flex align-items-center">
                                <Edit
                                  day={item}
                                  session={item.day_sessions}
                                  booked={item.booking}
                                  update={handleUpdatedTimeSlot}
                                  slotDuration={duration}
                                />

                                <LockDay
                                  lock={item.lock_day ? false : true}
                                  booked={item.booking}
                                  date={item.slot_date}
                                  dayAction={handleDayOnOff}
                                />
                              </span>
                            </div>
                            <p
                              className="text-start w-100 display-6"
                              style={{
                                color: item.lock_day ? "#CCCCCC" : "#000",
                              }}
                            >
                              {item.slot_date.slice(-2)}
                            </p>
                            <div className="w-100 d-flex justify-content-start align-items-center flex-column">
                              {(() => {
                                const sessions = Array.isArray(item.day_sessions)
                                  ? item.day_sessions
                                  : [];
                                const onlineSessions = sessions.filter(
                                  (session) => getSessionType(session) === "online"
                                );
                                const onsiteSessions = sessions.filter(
                                  (session) => getSessionType(session) === "onsite"
                                );

                                return (
                                  <>
                                    {onlineSessions.length > 0 && (
                                      <div className="w-100 mb-1">
                                        <p
                                          className="m-0 px-1"
                                          style={{
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: item.lock_day ? "#CCCCCC" : "#009B94",
                                          }}
                                        >
                                          Online Appointments
                                        </p>
                                        {onlineSessions.map((session, index) =>
                                          renderSessionRow(session, index, item, "online")
                                        )}
                                      </div>
                                    )}

                                    {onsiteSessions.length > 0 && (
                                      <div className="w-100">
                                        <p
                                          className="m-0 px-1"
                                          style={{
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: item.lock_day ? "#CCCCCC" : "#FF6760",
                                          }}
                                        >
                                          Onsite Appointments
                                        </p>
                                        {onsiteSessions.map((session, index) =>
                                          renderSessionRow(session, index, item, "onsite")
                                        )}
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              }
            </div>
          )}
        </div>
        <Toast
          cName={toast.cName}
          icon={toast.icon}
          text={toast.message}
          color={toast.iconColor}
        />
      </div>
      <style jsx="true">{`
        .booked:before {
          content: "";
          position: absolute;
          top: -14px;
          font-size: 11px;
          color: #009b94;
          font-weight: bold;
          margin: 0;
          left: 0;
          padding: 0;
          background: #009b94;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
        .booked:hover:after {
          content: "Booked";
          position: absolute;
          top: -17px;
          font-size: 11px;
          color: #009b94;
          font-weight: bold;
          margin: 0;
          left: 10px;
          padding: 0;
        }
        .rotating {
          -webkit-animation-name: spin;
          -webkit-animation-duration: 4000ms;
          -webkit-animation-iteration-count: infinite;
          -webkit-animation-timing-function: linear;
          -moz-animation-name: spin;
          -moz-animation-duration: 4000ms;
          -moz-animation-iteration-count: infinite;
          -moz-animation-timing-function: linear;
          -ms-animation-name: spin;
          -ms-animation-duration: 4000ms;
          -ms-animation-iteration-count: infinite;
          -ms-animation-timing-function: linear;
          animation-name: spin;
          animation-duration: 4000ms;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
        }
        @keyframes spin {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
      `}</style>
    </div>
  );
}
